import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/core/_config/app.config';
import { CreateCollectionExternalAgreementDto } from '../models/create-collectionExternal-agreement.model';
import { BoletoAcertoDto } from '../models/boleto-acerto.model';

@Injectable({
    providedIn: 'root',
})
export class ManageAgreementService {
    private API_URL = this.config.urlApi + 'api/v2/';

    constructor(private http: HttpClient, private config: AppConfig) {}

    createCollectionExternalAgreement(data: CreateCollectionExternalAgreementDto): Observable<any> {
        const baseUrl = this.config.urlApi.replace(/\/$/, '');
        const url = `${baseUrl}/api/v1/CollectionExternal/create-collectionExternalAgreement`;
        return this.http.post<any>(`${url}`, data);
    }

    getAgreements(params: any): Observable<any> {
        return this.http.get(`${this.API_URL}agreement-external`, params);
    }

    loadCompanies(): Observable<any> {
        const baseUrl = this.config.urlApi.replace(/\/$/, '');
        const url = `${baseUrl}/api/v1/CollectionExternal/GetCompanyExternal`;
        return this.http.get<any>(url);
    }

    getBilletsCollector(
        companyId: string,
        initialDate: string,
        finalDate: string,
        filterDateName: string,
        isInternalReceipt: string,
        receiptCode: string = '',
    ): Observable<BoletoAcertoDto[]> {
        const baseUrl = this.config.urlApi.replace(/\/$/, '');
        const url = `${baseUrl}/api/v1/CollectionExternal/GetBilletsCollector`;
        let isInternalReceiptValue: string;
        if (isInternalReceipt == '0') {
            isInternalReceiptValue = 'false';
        } else {
            isInternalReceiptValue = 'true';
        }
        return this.http.get<BoletoAcertoDto[]>(url, {
            params: {
                companyId,
                initialDate,
                finalDate,
                filterDateName: filterDateName.toString(),
                isInternalReceipt: isInternalReceiptValue,
                receiptCode,
            },
        });
    }

    deleteAgreement(companyId: string, codigoAcerto: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.API_URL}agreement-external/${companyId}/${codigoAcerto}`, {
            observe: 'response',
        });
    }
}
